// import Vue from 'vue';
import Vuex from 'vuex';
/* eslint-enable no-param-reassign */

function createStore() {
  return new Vuex.Store({
    state: {
      dark: false,
    },
    modules: {
    },
    getters: {
    },
    mutations: {
    },
  });
}

export default createStore;
